import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面未找到 - 密桃视频",
    description: "抱歉，你访问的页面不存在或已被移除。",
  });

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-4 py-20 text-center">
      <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        抱歉，你访问的页面不存在或已被移除，回首页继续浏览精彩内容吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          去搜索
        </Link>
      </div>
    </div>
  );
}